<template>
    <div class="game-over-round">
        <div class="game-over-round-header">
            0{{ round }}
        </div>
        <div class="game-over-round-decisions">
            <div v-for="(action, actionId) in getActions()" v-bind:key="'game over action' + actionId + 'in' + round"
                v-html="action">
            </div>
        </div>

        <template v-if="lastRound == false">
            <div v-if="getRiver() == 0" class="game-over-icon-river-0"></div>
            <div v-if="getRiver() == 1" class="game-over-icon-river-1"></div>
            <div v-if="getRiver() == 2" class="game-over-icon-river-2"></div>

            <div v-if="getStorm() == 1" class="game-over-icon-sea-1"></div>
            <div v-if="getStorm() == 2" class="game-over-icon-sea-2"></div>
            <div v-if="getStorm() == 4" class="game-over-icon-sea-4"></div>
        </template>

    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import Game from '../../../shared_fca/game';
import playerState, { getRoundReport } from '../../../shared_fca/playerstate';
import { T } from '@/App.vue';

export default Vue.extend({
    name: 'GameOverRound',
    props: {
        round: Number,
        game: Object as PropType<Game>,
        playerState: Object as PropType<playerState>,
        lastRound: Boolean,
    },
    methods: {
        getActions(): string[] {
            return getRoundReport(this.playerState, T, this.round - 1, "- ");
        },
        getRiver(): number {
            return this.game.riverStates[this.round];
        },
        getStorm(): number {
            return this.game.stormStates[this.round];
        }
    }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.game-over-round {
    width: 525px;
    height: 54px;
    position: relative;
}

.game-over-round:nth-child(odd) {
    background-color: #D9D9D9;
}

.game-over-round-header {
    font-family: Rubik;
    font-weight: 900;
    font-size: 27.69px;
    line-height: 32.82px;
    letter-spacing: 0.03px;
    color: #007D8D;
    position: absolute;
    left: 7.37px;
    top: 11.78px;
}

.game-over-round-decisions {
    font-family: Rubik;
    font-weight: 400;
    font-size: 11px;
    line-height: 13.04px;
    letter-spacing: 0px;
    color: #333333;
    position: absolute;
    top: 7.54px;
    left: 74.98px;
    overflow: hidden;
}

.game-over-icon-river {
    position: absolute;
    background-size: covert;
    width: 40px;
    height: 40px;
    top: 10.84px;
    left: 382.84px;
}

.game-over-icon-sea {
    .game-over-icon-river;
    left: 454.95px;
}

.game-over-icon-river-0 {
    .game-over-icon-river;
    background-image: url("../assets-fca/UI/game_over_river_none.svg");
}

.game-over-icon-river-1 {
    .game-over-icon-river;
    background-image: url("../assets-fca/UI/game_over_river_high.svg");
}

.game-over-icon-river-2 {
    .game-over-icon-river;
    background-image: url("../assets-fca/UI/game_over_river_severe.svg");
}

.game-over-icon-sea-1 {
    .game-over-icon-sea;
    background-image: url("../assets-fca/UI/game_over_storm_1.svg");
}

.game-over-icon-sea-2 {
    .game-over-icon-sea;
    background-image: url("../assets-fca/UI/game_over_storm_2.svg");
}

.game-over-icon-sea-4 {
    .game-over-icon-sea;
    background-image: url("../assets-fca/UI/game_over_storm_4.svg");
}
</style>